export default "__VITE_ASSET__Da3z0_D0__"